import React from "react"
import { HeadingLarge, componentStyles } from "@mallardbay/lib-react-components"

interface Props {
    readonly title: string
    readonly noMargin?: boolean
}

export default function CheckoutTitle({ title, noMargin }: Props) {
    const styles = useStyles({ noMargin })

    return <HeadingLarge style={styles.heading}>{title}</HeadingLarge>
}

function useStyles({ noMargin }: { noMargin?: boolean }) {
    return componentStyles({
        heading: {
            marginY: noMargin ? "0" : "16px",
        },
    })
}
